import { useState, useEffect } from "react";
import { useCollection } from "../../hooks/firestore/useCollection";
import ContentBlock from "../../components/contentBlock/ContentBlock";

import styles from "./Blogs.module.css";

export default function Blogs() {
  const { documents: allBlogs, error, isPending } = useCollection("blogs");

  useEffect(() => {
    const hash = window.location.hash.substring(1);

    const scrollToHash = () => {
      if (hash) {
        const element = document.getElementById(hash);
        // console.log("scrollToHash", hash, element);
        if (element) {
          element.scrollIntoView();
        } else {
          const interval = setInterval(() => {
            const element = document.getElementById(hash);
            if (element) {
              element.scrollIntoView();
              clearInterval(interval); // stop trying once the element is found
            }
          }, 500); // try every 500ms
        }
      }
    };

    if (!isPending && document.readyState === "complete") {
      scrollToHash();
    } else {
      const onLoad = () => {
        if (!isPending) {
          scrollToHash();
        }
        window.removeEventListener("load", onLoad);
      };
      window.addEventListener("load", onLoad);

      // Cleanup in case the component unmounts before the load event fires
      return () => {
        window.removeEventListener("load", onLoad);
      };
    }
  }, [isPending]);

  return (
    <div
      className={styles.blogs}
      style={{ backgroundColor: "white", color: "black" }}
    >
      <h1>News</h1>

      {error && <p>{error}</p>}
      {isPending && <p>Loading...</p>}

      {/* All blog entries in the collection */}
      {allBlogs &&
        allBlogs
          .sort((a, b) => b.created_at.toMillis() - a.created_at.toMillis())
          .map((doc) => (
            <div key={doc.id}>
              <BlogEntry doc={doc} />
            </div>
          ))}
    </div>
  );
}

function BlogEntry({ doc }) {
  const stories = doc.stories || [];
  return (
    <div>
      {/* TODO: use proper blog date */}
      <h2>{doc.id}</h2>

      {/* All stories in the blog entry */}
      {stories.map(
        (story, index) =>
          !story.draft && (
            <Story key={index} idPrefix={doc.id_prefix} story={story} />
          )
      )}
    </div>
  );
}

function Story({ idPrefix, story }) {
  const blocks = story.blocks || [];
  // internal anchor for each story is constructed from the blog's ID prefix and story id,
  // e.g. if the story is in a blog entry with id "2023-10-01" and the story id is "gdc-2025",
  // the internalId will be "2023-10-01-gdc-2025"
  // this is used to scroll to the story when the hash in the URL matches the internalId
  const internalId = `${idPrefix}-${story.id}`;

  return (
    <div id={internalId}>
      {/* Title */}
      <SectionHeader internalId={internalId} title={story.title} />
      {/* Content blocks */}
      {blocks.map((block, index) => (
        <ContentBlock key={index} inner={block} />
      ))}
    </div>
  );
}

function SectionHeader({ internalId, title }) {
  return (
    // show no title if the title is empty
    title && (
      <div>
        <h3 className={styles["story-title"]}>
          {title}
          {"   "}

          {/* Copy link button */}
          <button
            className={styles["copy-link-button"]}
            onClick={() => {
              const url = `${window.location.origin}${window.location.pathname}#${internalId}`;
              navigator.clipboard.writeText(url).then(() => {
                alert(`Đã copy đường dẫn vào clipboard:\n${url}`);
              });
            }}
          >
            🔗
          </button>
        </h3>
      </div>
    )
  );
}
